import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
//import DialogTitle from '@material-ui/core/DialogTitle';
import DialogTitle from './Dialog';
import Slide from '@material-ui/core/Slide';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { FiberManualRecord } from '@material-ui/icons';
import { getDateInStringDDMMMYYYY } from '../../../utils/utils';
import { TripArrowIcon } from '../../../components/icons';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { getVehicleNumberValuesDWeb,numberFormat } from '../../../utils/utils';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles((theme) => ({
  infoDialogTitle: {
    '& .MuiTypography-root ': {
      color: '#0b1323',
      fontWeight: 600,
      fontSize: 20,
      textTransform: 'capitalize'
    }
  },
  titleRoot:{
    color: '#0b1323',
    fontWeight: 600,
    fontSize: 20,
    textTransform: 'capitalize'
  },
  infoDialogText: {
    color: '#0b1323',
    fontSize: 14
  },
  closeButton: {
    color: '#0b1323',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: 14,
    opacity: 0.5
  },
  infoDialog: {
    //maxWidth:348,
    //minWidth:348
    '& .MuiPaper-root': {
      maxWidth: 395
    }
  },
  tripSummary:{
    width:"100%",
    backgroundColor:"#f1f3f6",
    borderRadius:8,
    padding:"12px 16px",
    marginBottom:24
  },
  content:{
    padding:"24px 26px",
    paddingTop:0
  },
  arrowIcon:{
    margin:"0px 4px",
    color:"#6d717b",
  },
  dot:{
    color:'#c7c7c7',
    fontSize:11,
    margin:"0px 4px",
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:first-child": {
      marginRight: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  },
  info: {
    padding: '12px 24px',
    borderRadius:8
  },
  normal:{
    paddingLeft:0,
    paddingBottom:16,
    paddingTop:0
  },
  normalList:{
    paddingLeft:0,
    paddingBottom:12,
    paddingTop:0
  },
  normalProfit:{
    paddingLeft:0,
    borderTop:'2px dotted rgba(107, 119, 140, 0.51)'
  },
  nested: {
    paddingLeft: 16,
    paddingBottom:5,
    paddingTop:5,
    paddingRight:24
  },
  nestedNoAction: {
    paddingLeft: 16,
    paddingBottom:5,
    paddingTop:5,
    paddingRight:80
  },
  primary:{
    fontSize:14,
    fontWeight:300
  },
  primaryNormal:{
    fontSize:14,
    fontWeight:600
  },
  primaryBalance:{
    fontSize:18,
    fontWeight:600
  },
  normalAmount:{
    fontSize:14,
    color:"#0b1323",
    fontWeight:300
  },
  expenseNormalAmount:{
    //color:'red',
    fontSize:18,
  },
  profitNormalAmount:{
    color:'#0033cc',
    fontSize:18,
    fontWeight:600
  },
  profitNegativeAmount:{
    color:'red',
    fontSize:18,
    fontWeight:600
  },
  primaryNested:{
    fontSize:16
  },
  primaryFreighNested:{
    fontSize:16,
    fontWeight:300
  },
  nestedAmount:{
    fontSize:18
  },
  nestedAmountFreight:{
    fontSize:16,
    fontWeight:300
  }
}));
export default function TripDetailsDialog(props) {
  const {
    mode,
    details,
    cancelText,
     confirmText,
      confirmMessage,
       confirmTitle,
        confirmOpen,
         onClose } = props;
  const [open, setOpen] = React.useState(confirmOpen);
  const [confirmMessageValue, setConfirmMessageValue] = useState("");
  const vehicleArray = details && details.vehicleNumber?getVehicleNumberValuesDWeb(details.vehicleNumber):[]
  const trans = mode && mode=="party"?details && details.customerTransactions?details.customerTransactions:{}:details && details.supplierTransactions?details.supplierTransactions:{}
  /*useEffect(() => {

    if (confirmMessage.includes(".")) {
      let split = confirmMessage.split('.');
      setConfirmMessageValue(split);
    } else {
      setConfirmMessageValue(confirmMessage);
    }

  }, [confirmOpen, confirmMessage]);*/

  const classes = useStyles();
  const handleNo = () => {
    setOpen(false)
    onClose(false);
  };
  const handleYes = () => {
    setOpen(false);
    onClose(true);
  };
  const handleClose = () => {
    setOpen(false);
    onClose(true);
  }
  return (
    <div>
      <Dialog
        open={open}
        maxWidth='xs'
        className={classes.infoDialog}
        //TransitionComponent={Transition}
        // keepMounted
        onClose={handleClose}
        aria-labelledby="tripDetailsDiaglog-dialog-slide-title"
        aria-describedby="tripDetailsDiaglog-dialog-slide-description"
        disableEscapeKeyDown={true}
        disableEscapeKeyDown={true} 
        disableBackdropClick={true}
        fullWidth={true}
        //onEscapeKeyDown={handleYes}
      >
        <DialogTitle id="InfoDialog-dialog-slide-title" onClose={handleClose} classes={{root:classes.titleRoot}}>{confirmTitle}</DialogTitle>
        <DialogContent className={classes.content}>
            <div className={classes.tripSummary}>
              <div style={{display:'flex',alignItems:'center',color:"#0b1323",fontSize:14,fontWeight:600,marginBottom:10}}>
                  <div>{details && details.startLocation?details.startLocation:""}</div>
                  <div><ArrowRightIcon className={classes.arrowIcon} /></div>
                  <div>{details && details.destinationLocation?details.destinationLocation:""}</div>
              </div>
              <div style={{display:'flex',alignItems:'center'}}>
                  <div style={{color:"#6d717b",fontSize:12}}>{details && details.tripStartDate?getDateInStringDDMMMYYYY(details.tripStartDate):""}</div>
                  {vehicleArray && vehicleArray.length > 2 ?<><div><FiberManualRecord className={classes.dot} /></div>
                  <div style={{ display: 'flex', textTransform: 'uppercase' }}>
                      {vehicleArray && vehicleArray.length > 2 && vehicleArray.map((item) => (
                          <div className={classes.vehileNumber}>{item}</div>
                      ))
                      }
                  </div></>:""}
              </div>
            </div>
            <div>
            {mode && mode=="party" && <List
              component="nav"
              aria-labelledby="profit-summary-list"
              className={classes.root}
            >
              <ListItem  className={classes.normal}>
                <ListItemText primary={"Freight Amount"} classes={{primary:classes.primaryNormal}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.freight?trans.freight:0))}</span>
              </ListItem>
              <ListItem  className={classes.normalList}>
                <ListItemText primary="Charges" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.charge?trans.charge:0))}</span>
              </ListItem>
              <ListItem  className={classes.normalList}>
                <ListItemText primary="Deductions" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.deduction?trans.deduction:0))}</span>
              </ListItem>
              {mode && mode =="party"?<ListItem  className={classes.normalList}>
                <ListItemText primary="Advance" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.trans?trans.advance:0))}</span>
              </ListItem>:""}
              <ListItem  className={classes.normal}>
                <ListItemText primary="Payment" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.payment?trans.payment:0))}</span>
              </ListItem>
              <ListItem  className={classes.normalProfit}>
                <ListItemText primary="Balance" classes={{primary:classes.primaryBalance}} />
                <span className={Number(details && details.customerTransactions && details.customerTransactions.balance?details.customerTransactions.balance:0)<1?classes.profitNegativeAmount:classes.profitNormalAmount}>{numberFormat(Number(details && details.customerTransactions && details.customerTransactions.balance?details.customerTransactions.balance:0))}</span>
              </ListItem>
            </List>}
            {mode && mode=="supplier" && <List
              component="nav"
              aria-labelledby="profit-summary-list"
              className={classes.root}
            >
              <ListItem  className={classes.normal}>
                <ListItemText primary={"Truck Hire Cost"} classes={{primary:classes.primaryNormal}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.truckHireCost?trans.truckHireCost:0))}</span>
              </ListItem>
              <ListItem  className={classes.normalList}>
                <ListItemText primary="Supplier Charges" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.supplierCharge?trans.supplierCharge:0))}</span>
              </ListItem>
              <ListItem  className={classes.normalList}>
                <ListItemText primary="Supplier Deductions" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.supplierDeduction?trans.supplierDeduction:0))}</span>
              </ListItem>
              <ListItem  className={classes.normal}>
                <ListItemText primary="Supplier Payments" classes={{primary:classes.primary}} />
                <span className={classes.normalAmount}>{numberFormat(Number(trans && trans.supplierPayment?trans.supplierPayment:0))}</span>
              </ListItem>
              <ListItem  className={classes.normalProfit}>
                <ListItemText primary="Supplier Balance" classes={{primary:classes.primaryBalance}} />
                <span className={Number(trans && trans.supplierBalance?trans.supplierBalance:0)<1?classes.profitNegativeAmount:classes.profitNormalAmount}>{numberFormat(Number(trans && trans.supplierBalance?trans.supplierBalance:0))}</span>
              </ListItem>
            </List>}
            </div>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleYes} className={classes.closeButton}>
            {confirmText ? confirmText : 'Close'}
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
}